/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, styled } from "@mui/material";
import { CHARGE_TYPE_COLORS, STATUS_COLORS } from "./serviceChargeUtils";

export const ServiceChargePage = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

// Same pill as the Configured Perqs classification.
export const ChargeTypePill = styled(Box, { shouldForwardProp: (prop) => prop !== 'chargeType' })(({ chargeType }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${CHARGE_TYPE_COLORS[chargeType]}20`,
  color: CHARGE_TYPE_COLORS[chargeType],
  fontSize: '0.775rem',
}))

export const StatusText = styled('span', { shouldForwardProp: (prop) => prop !== 'status' })(({ status }) => ({
  color: STATUS_COLORS[status],
  fontWeight: status === 'needs_type' ? 600 : 400,
}))
